export enum Language {
    RU = 'RU',
    TJ = 'TJ'
}